import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const storedUser = localStorage.getItem('user');
      const storedToken = sessionStorage.getItem('token');
      
      if (
        storedUser &&
        storedToken &&
        storedToken !== 'null' &&
        storedToken !== 'undefined' &&
        storedToken.length > 10
      ) {
        const parsedUser = JSON.parse(storedUser);
        
        // Validate user data has required fields
        if (parsedUser && parsedUser.role) {
        setUser(parsedUser);
      } else {
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        setUser(null);
      }
      } else {
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        setUser(null);
      }
    } catch (error) {
        console.error('Error parsing stored user data:', error);
        localStorage.removeItem('user');
        sessionStorage.removeItem('token');
        localStorage.removeItem('token');
        setUser(null);
      } finally {
      setLoading(false);
    }
  }, []);

const login = (userData, token) => {
  const userWithRole = {
    ...userData,
    role: userData.role || 'MERCHANT',
  };

  delete userWithRole.token;
  delete userWithRole.accessToken;

  if (typeof token === 'string') {
    sessionStorage.setItem('token', token);
  }

  localStorage.setItem('user', JSON.stringify(userWithRole));
  setUser(userWithRole);
};

  const logout = () => {
    sessionStorage.removeItem('token');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
